import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ALL BRANCHES-----------------------------*/
export const getAllObjectives = createAsyncThunk(
  "objectives/get-objectives",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}association/objectives`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
